import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { NouisliderModule } from 'ng2-nouislider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';

import { CoreCommonModule } from '@core/common.module';
import { CoreDirectivesModule } from '@core/directives/directives';
import { CorePipesModule } from '@core/pipes/pipes.module';
import { CoreSidebarModule } from '@core/components';

import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';

import { TranslateModule } from "@ngx-translate/core";
import {FaqComponent} from "./faq/faq.component";
import {ReturnsWarrantiesComponent} from "./returns-warranties/returns-warranties.component";

// routing
const routes: Routes = [
  {
    path: 'faq',
    component: FaqComponent,
    data: { animation: 'FaqComponent' },
    pathMatch: 'full'
  },
  {
    path: 'returns-warranties',
    component: ReturnsWarrantiesComponent,
    data: { animation: 'ReturnsWarrantiesComponent' },
    pathMatch: 'full'
  }
];

@NgModule({
  declarations: [
    FaqComponent,
    ReturnsWarrantiesComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    CoreCommonModule,
    FormsModule,
    NgbModule,
    NouisliderModule,
    NgSelectModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    CorePipesModule,
    CoreDirectivesModule,
    CoreSidebarModule,
    TranslateModule,
    ContentHeaderModule,
  ],
  providers: []
})

export class StaticModule {}
